import { Component, OnInit, OnDestroy } from "@angular/core";
import * as moment from "moment-timezone";
import { sweetAlert } from "src/app/utils/swal";
import { MemberService } from "../member-service/member.service";
import { DriversService } from "../../drivers/drivers-service/drivers-service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import * as _ from 'underscore';
import { CorporateService } from "../../corporate-user/corporate-service/corporate-service";


@Component({
  selector: "app-member-list",
  templateUrl: "./member-list.component.html",
  styleUrls: ["./member-list.component.css"],
})
export class MemberListComponent implements OnInit, OnDestroy {
  members = []
  selectedMembers= []
  assignDriverArray = [];
  user;
  selecetedMember;
  search = '';
  status = "active";
  throughApi = true;
  isAllMemberSelected = false;
  showSlideFilter: boolean = false;
  memberStatusObj;
  p: number = 1;
  memberTripsObj: any;
  skip = 0;
  corporateUsers:any;
  selectedFundingSources = [];
  filteredMembers= [];
  markMembersAsPrimaryObj;
  isLoading = false;
  preCorporateUsers = {};
  


  constructor(
    private corporateService: CorporateService,
    private memberService: MemberService,
    private sharedDataService: SharedDataService
  ) {
  }

  ngOnInit() {
    this.getUser();
  }

  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user;
          this.getcorporateUsers();
          this.getMembers();
        }
      });
  }

  onChangeStatus() {
    this.skip = 0;
    this.members = [];
    this.getMembers();
  }
  onChangeAPI(evt){
    this.throughApi = JSON.parse(evt);
    this.skip = 0;
    this.members = [];
    this.getMembers();
  }
 getMembers() {
  if (this.isLoading) return;

  this.isLoading = true;

  const queryParam = {
    accountStatus: this.status,
    throughApi: this.throughApi,
    skip: this.skip,
    displayName: this.search
  };

  this.memberService
    .getMembers(queryParam)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (queryParam.displayName !== this.search) return;  // old search response, ignore it
      if (data) {
        this.members = [...this.members, ...data];
        this.skip += data.length;
        this.applyFundingSourceFilter();
        this.isLoading = false;
      }
    });
}


  onSelectMember(member) {
    const index = this.selectedMembers.indexOf(member._id);
    if (index > -1) {
      member.isSelected = false;
      this.selectedMembers.splice(index, 1);
    } else {
      member.isSelected = true;
      this.selectedMembers.push(member._id);
    }
  }

  selectAllTrips() {
    this.members.forEach((member) => {
      member.isSelected = true;
      if (!this.selectedMembers.includes(member._id))
        this.selectedMembers.push(member._id);
    });
    // }

    this.isAllMemberSelected =
      this.selectedMembers.length === this.members.length;
    return this.isAllMemberSelected;
  }


  showFilter() {
    this.showSlideFilter = !this.showSlideFilter;
  }

  closeFilter() {
    this.showSlideFilter = false;
  }

  openStatusModal(){
    this.memberStatusObj = this.selectedMembers
  }


  unSelectAllTrips() {
    const unSelectedMembers = [];
    this.members.forEach((member) => {
      member.isSelected = false;
      unSelectedMembers.push(member._id);
    });

    this.selectedMembers = this.selectedMembers.filter(x => !unSelectedMembers.includes(x));
    this.isAllMemberSelected = false;
  }

  getSelectedTrips() {
    return this.selectedMembers
      .filter((member) => member.isSelected);

  }

  assignDriver(member) {
    this.selecetedMember = JSON.parse(JSON.stringify(member));
    this.assignDriverArray = [];
    let object = this.getAllDays();
    for (let i = 0; i < this.selecetedMember.scheduler.length; i++) {
      object = object.map((item) => {
        if (item.day === this.selecetedMember.scheduler[i].day) {
          item.driver = this.selecetedMember.scheduler[i].driver;
          item.isSelect = true;
        }
        return item;
      });
    }
    this.assignDriverArray = object;
  }

  saveModalData() {
    this.selecetedMember.scheduler = this.assignDriverArray.filter(
      (item) => item.isSelect && item.driver !== ""
    );

    this.memberService
      .updateMember(this.selecetedMember)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.members.filter((obj) => {
              if (obj._id === data._id) {
                // obj.scheduler =  data.scheduler;
                obj.updatedAt =  data.updatedAt;
              }
            });
        }
      });
  }

  trackByFn(index, item) {
    if (!item) return;
    return item._id;
  }


  getAllDays() {
    const weekdays = moment.weekdaysShort();
    let object = [];
    for (let i = 0; i < weekdays.length; i++) {
      const innerObject = {
        day: weekdays[i],
        driver: "",
        isSelect: false,
      };
      object.push(innerObject);
    }
    return object;
  }

  openMemberTrips(trips){
    this.memberTripsObj = trips
  }
  closeMemberTrips(trips){
    this.memberTripsObj = null
  }

  onScroll(evt: Event): void {
    const element = evt.target as HTMLElement;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight && !this.isLoading) {
      this.getMembers(); 
      element.scrollTop = 0 ;
      // element.clientHeight = 0;
    }
  }

  onMemberSearch(){
    this.skip = 0;  // Reset skip on new search
    this.members = [];  // Clear previous members
    this.isLoading = false; 
    this.getMembers();  // Call API with new search term
  }

  getcorporateUsers() {
    this.corporateUsers = [];
    this.corporateService
      .getCorporateUsers(this.status)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.length) {
          this.corporateUsers = data;
          this.preCorporateUsers = data.reduce((obj, item) => (obj[item._id] = item, obj), {});
        }
      }, err => {
        sweetAlert('Error', err, 'warning', 'OK');
      });
  }

  onFundingSourceChange() {
    this.applyFundingSourceFilter();
  }

  applyFundingSourceFilter() {
    if (this.selectedFundingSources.length > 0) {
      this.filteredMembers = this.members.filter(member =>
        this.selectedFundingSources.includes(member.fundingSource)
      );
    } else {
      this.filteredMembers = [...this.members];
    }
  }

  openMarkMemberAsPrimaryModal() {
    this.markMembersAsPrimaryObj = JSON.parse(JSON.stringify(this.members.filter(m => this.selectedMembers.includes(m._id))));
  }

  closeMarkMemberAsPrimaryModal(secondaries) {
    this.markMembersAsPrimaryObj = null;
    if (secondaries && secondaries.length) {
      this.members = this.members.filter(member => !secondaries.includes(member._id));
      this.filteredMembers = this.filteredMembers.filter(member => !secondaries.includes(member._id));
      this.selectedMembers = this.selectedMembers.filter(id => !secondaries.includes(id));
    }
  }

  ngOnDestroy(): void {
  }
}
